export default function (baseApi, baseApiLambda) {
  return {
    // intervals: {
    //   logout: 3600 // 1 hour in seconds
    // },
    // token: {
    //   auth: process.env.AUTH_TOKEN
    // },
    baseApi,
    baseApiLambda,
    isProduction: true,
    isDevelopment: false,
    isStage: false,
  };
}
